import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Home, Feather, Video, BarChart2, Calendar, Map, Plus, Building, Phone, Tv } from "lucide-react";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";

const ICONS = { home: Home, feather: Feather, video: Video, "bar-chart-2": BarChart2, calendar: Calendar, map: Map, "plus-circle": Plus, building: Building, phone: Phone, tv: Tv };

export default function Sidebar({ open, onClose }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/menu").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose}></div>
      )}
      <aside className={`fixed top-0 left-0 h-full w-72 bg-white shadow-2xl z-50 transform transition-transform ${open ? "translate-x-0" : "-translate-x-full"}`}>
        <div className="flex items-center justify-between px-4 h-16 border-b border-gray-200">
          <Logo size="sm" />
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded"><X className="w-5 h-5" /></button>
        </div>
        <nav className="py-2">
          {items.map((it) => {
            const Icon = ICONS[it.icon] || Home;
            return (
              <Link key={it.id} to={it.path} onClick={onClose} className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 border-b border-gray-100 text-sm font-medium">
                <span className="w-9 h-9 inline-flex items-center justify-center rounded-md bg-gray-50 text-[#e11d2a]"><Icon className="w-5 h-5" /></span>
                {it.label}
              </Link>
            );
          })}
        </nav>
        <div className="px-4 py-4 text-xs text-gray-500">
          © {new Date().getFullYear()} SİNE81. Tüm hakları saklıdır.
        </div>
      </aside>
    </>
  );
}
